import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class TrackerService {

    private baseUrl: string;
    constructor(
        private http: HttpClient
    ) {
        this.baseUrl = environment.baseUrl
    }

    getDeviceName(region) {
        return this.http.get(this.baseUrl + '/data/distinct/aliasName?region=' + region);
    }

    getDeviceNameByMessengerName(region) {
        return this.http.get(this.baseUrl + '/data/distinct/messengerName?region=' + region);
    }

    getMessageType(region) {
        return this.http.get(this.baseUrl + '/data/distinct/messageType?region=' + region);
    }

    getLastPositionPerTracker(region) {
        return this.http.get(this.baseUrl + '/data/aggregate?region=' + region);
    }

    getLastPosition(trackerName, region) {
        return this.http.get(this.baseUrl + '/data/name/' + trackerName + '?region=' + region);
    }

    getPositionBySpotAndType(spot, type, region) {
        const query = {
            messageType: type,
            aliasName: spot
        }
        return this.http.post(this.baseUrl + '/data/search?region=' + region, query);
    }

    getPositionByDate(from, to, region) {
        const query = {
            dateTime: { $gte: from, $lte: to}
        }
        console.log("QUERY", query);
        return this.http.post(this.baseUrl + '/data/search?region=' + region, query);
    }
}